import React, {ReactNode} from 'react';

interface Props {
  children: ReactNode;
  borderBottom?: boolean;
}

const Section = ({children, borderBottom = false}: Props) => (
  <div className={`section portfolio-section ${borderBottom ? 'portfolio-section-border' : ''}`}>
    <div className="portfolio-section-wrapper">{children}</div>
  </div>
);

export default Section;
